import React from 'react';

export const Laptop = ({ className }) => {
  return (
    <svg viewBox="0 0 130 98" fill="none" className={className}>
      <rect
        x="2"
        y="2.95654"
        width="125.682"
        height="93.0138"
        rx="2.94968"
        fill="white"
        stroke="#2A4365"
        strokeWidth="4"
      />
      <circle cx="64.8409" cy="12.836" r="2.96981" fill="#2A4365" />
    </svg>
  );
};
